var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" input_config "),_c('el-input',{model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "+_vm._s(_vm.videoData)+" "),_c('div',{on:{"click":_vm.clickFun}},[_vm._v(" 点击展示 选择视频弹窗 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }